import _ from 'lodash';

export enum TextToken {
  CUSTOM_TEXT = '{{customText',
  INSERT_EMAIL_FRAGMENTS = '{{insertEmailFragments',
  ADD_TO_CALENDAR = '{{addToCalendar',
}

export function hasToken(textContent: string): boolean {
  return _(TextToken)
    .values()
    .some(token => textContent.includes(token));
}
